import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { sessionQuery } from '#admin/features/auth/queries.ts'
import { can } from '#admin/features/auth/session.ts'
import { OrganizationForm } from '#admin/features/organization/organization-form.tsx'
import { OrganizationSkeleton } from '#admin/features/organization/organization-skeleton.tsx'
import { organizationQuery } from '#admin/features/organization/queries.ts'
import { ReadOnlyNotice } from '#admin/components/read-only-notice.tsx'

/** `/settings/organization`: who issues this edition's invoices. The feature owns the rest. */
export const Route = createFileRoute('/_authenticated/settings/organization')({
  pendingComponent: OrganizationSkeleton,
  staticData: { crumb: { parents: [{ label: 'Settings' }], label: 'Organization' } },
  loader: ({ context }) => context.queryClient.ensureQueryData(organizationQuery()),
  component: OrganizationSettingsPage,
})

function OrganizationSettingsPage() {
  const { data } = useSuspenseQuery(organizationQuery())
  const { data: session } = useSuspenseQuery(sessionQuery())
  const canManage = can(session, 'identity.manage')

  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-xl font-semibold">Organization</h1>
        <p className="text-sm text-muted-foreground">
          The event that delegates see when they register, and the company behind it, as its
          invoices name it: legal name, tax ID, contact details and logos.
        </p>
      </header>

      {canManage ? null : <ReadOnlyNotice area="the organization details" />}
      <OrganizationForm initial={data} readOnly={!canManage} />
    </div>
  )
}
